"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StringUtils_1 = require("./StringUtils");
var getPropErrors = function (prop, errors) {
    return errors ? errors.filter(function (e) { return e.prop === prop; }) : [];
};
exports.getPropErrors = getPropErrors;
var getPropErrorMessage = function (prop, errors) {
    var es = getPropErrors(prop, errors);
    return es.length > 0 ? StringUtils_1.join(es, function (e) { return e.message; }) : "";
};
exports.getPropErrorMessage = getPropErrorMessage;
